export default __webpack_public_path__ + "static/media/fonts/AlegreyaSans-Bold.1e3960b4.ttf";